import React from 'react';
import ContentContainer from 'templates/content-container/contentContainer';
import ContentContainerToolbar from 'ui-components/molecules/content-container-toolbar/contentContainerToolbar';
import Table from 'ui-components/table/table';
import { getWeeks } from './getWeeks';
import { useHistory } from 'react-router-dom';
import Button, { ButtonSizes, ButtonThemes } from 'ui-components/button/button';
import TargetWeek from './sidebars/targetWeek';
import { useBuildWeek } from './hooks/useBuildWeek';
import UpdateWeek from './sidebars/updateWeek';
import { useDeleteWeek, useWeeks } from './hooks/useWeek';

const CloneWeek: React.FC = () => {
  const history = useHistory();

  const [selectedWeek, setSelectedWeek] = React.useState<string>("");
  const [division, setDivision] = React.useState<string>("");
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [updateWeekModalOpen, setUpdateWeekModalOpen] = React.useState<boolean>(false);
  const [isEdit, setIsEdit] = React.useState<boolean>(false);
  const [editWeek, setEditWeek] = React.useState<{ weekStartDate: string; division: string; weekDescription: string; scheduleType: string } | null>(null);

  const { data: weekOptionsData, isLoading: isLoadingWeeks, refetch } = useWeeks();
  const buildWeekMutation = useBuildWeek(() => refetch());
  const deleteWeekMutation = useDeleteWeek(() => refetch());

  const handleBuildWeek = (weekStartDate: string, division: string) => {
    buildWeekMutation.mutate({
      division,
      weekStartDate,
    });
  };

  const handleEdit = (weekStartDate: string, division: string, weekDescription: string, scheduleType: string) => {
    setUpdateWeekModalOpen(true);
    setIsEdit(true);
    setEditWeek({
      weekStartDate,
      division,
      weekDescription,
      scheduleType
    });
  };

  const handleDelete = (weekStartDate: string, division: string) => {
    deleteWeekMutation.mutate({
      division,
      weekStartDate,
    });
  }

  return <ContentContainer mods={{ "full-width": true }}
    titleComponent={
      <div className='clone-week-container-toolbar'>
        <ContentContainerToolbar
          title="Clone a Week"
          tooltip={"This module is in Preview. Certain data and features may be incomplete or under development."}
          status={"PREVIEW"}>
          <Button theme={ButtonThemes.blue} size={ButtonSizes.auto} onClick={() => {
            setUpdateWeekModalOpen(true);
            setIsEdit(false);
          }}>Create week</Button>
          <Button theme={ButtonThemes.blue} size={ButtonSizes.auto} onClick={() => history.push(`/static-load/work-with-manifest`)}>Work with Manifest</Button>
          <Button theme={ButtonThemes.blue}
            size={ButtonSizes.auto}
            disabled={!selectedWeek}
            onClick={() => setModalOpen(true)}>Proceed to clone</Button>
        </ContentContainerToolbar>
      </div>
    }
  >
    <div className='clone-week-container'>
      <Table
        data={weekOptionsData ?? []}
        columns={getWeeks(selectedWeek, setSelectedWeek, setDivision, buildWeekMutation.isLoading, handleBuildWeek, handleEdit, handleDelete)}
        isLoading={isLoadingWeeks}
      />
    </div>
    <TargetWeek
      isOpen={modalOpen}
      onClose={() => setModalOpen(false)}
      isLoading={false}
      weekStartDate={selectedWeek}
      division={division}
      refetchGetWeeks={refetch}
    />
    <UpdateWeek
      isOpen={updateWeekModalOpen}
      onClose={() => setUpdateWeekModalOpen(false)}
      isLoading={false}
      refetchGetWeeks={refetch}
      isEdit={isEdit}
      editWeek={editWeek ?? { weekStartDate: "", division: "", weekDescription: "", scheduleType: "" }} />
  </ContentContainer>
};

export default CloneWeek;
